import { combineReducers } from "redux";
import CompanyReducer from "../containers/company/redux/Reducer";
import DivisionReducer from "../containers/division/redux/Reducer";
import RegionReducer from "../containers/region/redux/Reducer";
import MarketReducer from "../containers/market/redux/Reducer";
import AcquisitionReducer from "../containers/acquisition/redux/Reducer";
import DensityReducer from "../containers/density/redux/Reducer";
import ClassificationReducer from "../containers/store-classification/redux/Reducer";
import CompGroupReducer from "../containers/commission-comp-group/redux/Reducer";
import ChannelTypeReducer from "../containers/storeChannelType/redux/Reducer"
import AlertReducer from "../containers/alert/Reducer";
import StoreReducer from "../containers/stores/redux/Reducer";
import DashboardReducer from "../containers/home/redux/Reducer";
import StoreHoursReducer from "../containers/store-hours/redux/Reducer";
import DepartmentReducer from "../containers/employee_departments/redux/Reducer"
import LeaveTypeReducer from "../containers/employee_leave_type/redux/Reducer"
import EmployeeTypeReducer from "../containers/employee_type/redux/Reducer"
import JobTitleReducer from "../containers/jobtitles/redux/Reducer"
import EmployeeStatusReducer from "../containers/employee_status/redux/Reducer"
import EmployeeReducer from "../containers/employees/redux/Reducer"
import HireStatusReducer from "../containers/hire-status/redux/Reducer";
import TermReasonReducer from "../containers/term-reason/redux/Reducer";
import FullPartTimeReducer from "../containers/full_part_time_status/redux/Reducer";
import HourlySalaryReducer from "../containers/hourly_salary_status/redux/Reducer";
import NextPrevReducer from "../containers/next_prev_redux/Reducer"
import QueueTableReducer from "../containers/queue_table/redux/Reducer"
import QuarterlyReviewReducer from "../containers/quarterlyReview/redux/Reducer";
import LoginReducer from "../containers/login/redux/Reducer";
import RoleReducer from "../containers/roles/redux/Reducer";
import GroupReducer from "../containers/groups/redux/Reducer";
import ModuleReducer from "../containers/module_meta_data/redux/Reducer";
import RoleModuleReducer from "../containers/role_module_mapping/redux/Reducer";
import EmployeeRoleReducer from "../containers/employee_role_mapping/redux/Reducer";
import FilterReducer from "../containers/table_filters_redux/Reducer";
import OdooStoreTransferTrackersReducer from "../containers/odoo_reference/OdooStoreTransferTracker/redux/Reducer";
import OdooDesignationTrackerReducer from "../containers/odoo_reference/OdooDesignationTracker/redux/Reducer";
import KeyTagReducer from "../containers/tagging/redux/Reducer";
import auditReducer from "../containers/auditLog/redux/Reducer"
import hireTermQueueReducer from '../containers/hireTermQueue/redux/Reducer'
import groupJobTitleReducer from '../containers/group_jobtitles/redux/Reducer'
import tShirtReducer from '../containers/salesUsers/redux/Reducer'
import productTables  from "../containers/productUI/productTables/redux/Reducer";
import products from "../containers/productUI/products/redux/Reducer";
import rfVisits from "../containers/retail_foundation/redux/Reducer";
import searchsap from "../containers/search-sap/redux/Reducer";
import dynamicForm from "../containers/dynamic_form/redux/Reducer";
import myPlan from "../containers/my_plan/redux/Reducer";
import chatgroup from "../containers/chat/redux/Reducer";
import notification from "../containers/notification/redux/Reducer";
import categories from "../containers/vision_hub/categories/redux/Reducer";
import ticketingDropdownReducer, {escalationReducer, DropdownReducer, RuleListReducer, escalationGetDataReducer, escalationExecutionListReducer} from "../containers/vision_hub/escalation_rule_builder/redux/Reducer";
import {allUsersReducer, createTicketReducer} from "../containers/ticketing/ticketcreation/redux/Reducer";
import {Reducer as ticketing, UserTicketFilterReducer, AdminTicketsReducer, messageTemplateDropdownReducer} from "../containers/ticketing/ticketing/redux/Reducer"
import {articleListReducer,articleDetailsReducer} from "../containers/vision_hub/articleList/redux/Reducer";
import question from "../containers/vision_hub/questions/redux/Reducer";
import { messageTemplateActionReducer, messageTemplatePostReducer, msgTemplatesListReducer } from "../containers/messageList/redux/Reducer";
import SeatBookingReducer from "../containers/seat_booking/redux/Reducer"
import EmailRuleReducer from "../containers/vision_hub/email_rule/redux/Reducer"
import AlarmPageReducer from "../containers/alarmpage/redux/Reducer";
import AdminGroup from "../containers/vision_hub/admin_group/redux/Reducer";
import TicketDashboardMetrics from "../containers/ticketing/kpi_dashboard/redux/Reducer"
import PowerBIReportsReducer from "../containers/power-bi-portal/redux/Reducer";
import PowerBISecurityReducer from "../containers/power-bi-security/redux/Reducer";

const RootReducer = combineReducers({
  company: CompanyReducer,
  division: DivisionReducer,
  region: RegionReducer,
  market: MarketReducer,
  acquisition: AcquisitionReducer,
  density: DensityReducer,
  classification: ClassificationReducer,
  compgroup: CompGroupReducer,
  channelType: ChannelTypeReducer,
  alert: AlertReducer,
  store: StoreReducer,
  dashboardCount: DashboardReducer,
  storeHours: StoreHoursReducer,
  department: DepartmentReducer,
  leaveType: LeaveTypeReducer,
  employeeType: EmployeeTypeReducer,
  jobtitle: JobTitleReducer,
  employeeStatus: EmployeeStatusReducer,
  employee: EmployeeReducer,
  hireStatus: HireStatusReducer,
  termReason: TermReasonReducer,
  fullPartTime: FullPartTimeReducer,
  hourlySalary: HourlySalaryReducer,
  nextPrev: NextPrevReducer,
  tableFilter: FilterReducer,
  login: LoginReducer,
  roles: RoleReducer,
  groups: GroupReducer,
  modules: ModuleReducer,
  roleModules: RoleModuleReducer,
  empRoles: EmployeeRoleReducer,
  odooStoreTransferTrackers: OdooStoreTransferTrackersReducer,
  odooDesignationTrackers: OdooDesignationTrackerReducer,
  keyTag: KeyTagReducer,
  queueTable: QueueTableReducer,
  quaterly: QuarterlyReviewReducer,
  audits:auditReducer,
  hireTermQueue:hireTermQueueReducer,
  groupJobtitle: groupJobTitleReducer,
  tShirtReducer: tShirtReducer,
  productTables: productTables,
  products: products,
  rfVisits: rfVisits,
  searchsap: searchsap,
  forms: dynamicForm,
  myPlans: myPlan,
  chatgroup: chatgroup,
  notification: notification,
  categories: categories,
  escalationRule: escalationReducer,
  dropdown: DropdownReducer,
  ruleList: RuleListReducer,
  ticketingDropdowns: ticketingDropdownReducer,
  escalationDataService: escalationGetDataReducer,
  allUsers:allUsersReducer,
  createTicket: createTicketReducer,
  ticketing: ticketing,
  userTicketFilter:UserTicketFilterReducer,
  adminTickets: AdminTicketsReducer,
  articleList: articleListReducer,
  articleDetails: articleDetailsReducer,
  question: question,
  msgTemplatesList: msgTemplatesListReducer,
  messageTemplatePost: messageTemplatePostReducer,
  messageTemplateAction: messageTemplateActionReducer,
  messageTemplateDropdown: messageTemplateDropdownReducer,
  escalationExecutionList: escalationExecutionListReducer,
  seatBooking: SeatBookingReducer,
  EmailRule: EmailRuleReducer,
  alarmPage: AlarmPageReducer,
  AdminGroup: AdminGroup,
  TicketDashboardMetrics: TicketDashboardMetrics,
  powerBIReports: PowerBIReportsReducer,
  powerBISecurity: PowerBISecurityReducer,
});

export default RootReducer;
